import React from 'react'

import { array, object, string } from 'prop-types'

import PromoCards from '../PromoCards'
import BudgetItem from './BudgetItem'
import i18n from 'Pods/Shared/I18n'

function BudgetSection({ budgetItems, promoItems, locale = 'en' }) {

  const budgetSectionTitle = i18n.t('printModelPage.budgetSectionTitle', { ns: 'rails', lng: locale })
  const budgetSectionDescription = i18n.t('printModelPage.budgetSectionDescription', { ns: 'rails', lng: locale })

  return (
    <div className="categories-section__budget-section">
      <div className="categories-section__budget">
        <div className="categories-section__budget-header">
          <h3 className="categories-section__budget-title">{budgetSectionTitle}</h3>
          <span className="categories-section__budget-description">
            {budgetSectionDescription}
          </span>
        </div>
        <div className="categories-section__budget-content">
          <BudgetItem
            title={budgetItems[0].label}
            href={budgetItems[0].href}
            count={budgetItems[0].itemCount}
            icon="low_budget"
          />
          <BudgetItem
            title={budgetItems[1].label}
            href={budgetItems[1].href}
            count={budgetItems[1].itemCount}
            icon="mid_budget"
          />
          <BudgetItem
            title={budgetItems[2].label}
            href={budgetItems[2].href}
            count={budgetItems[2].itemCount}
            icon="high_budget"
          />
        </div>
      </div>
      <div className="categories-section__promo-section">
        <PromoCards
          onSale={promoItems.onSale}
          freeItems={promoItems.freeItems}
          locale={locale}
        />
      </div>
    </div>
  )
}

BudgetSection.propTypes = {
  budgetItems: array.isRequired,
  promoItems: object.isRequired,
  locale: string,
}

export default BudgetSection
